import React, {useEffect, useState} from 'react'
import {setTitlePage} from '../../../Functions'
import {getProducts} from '../../../Api'
import '../marketplace.scss'
import {AlertDialog} from '../../../components/Dialog/Dialog'
import {Modal} from 'react-bootstrap'
import LazyImage from '../../../components/LazyImage'
import ModalProduct from '../components/ModalProduct'
import {useNavigate} from 'react-router-dom'
import {IProduct} from '..'

const MyProducts: React.FC = () => {
  const [loading, setLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [img, setImg] = useState('')
  const [productSelected, setProductSelected] = useState<IProduct | {} | null>(null)
  const [products, setProducts] = useState<IProduct[]>([])
  const navigate = useNavigate()

  useEffect(() => {
    setTitlePage('Marketplace - Mis avisos')
    handleLoadData()
  }, [])

  const handleLoadData = async () => {
    try {
      setLoading(true)
      const {
        data: {productos = []},
      } = await getProducts({showMine: true})
      setLoading(false)
      setProducts(productos)
    } catch (error: any) {
      setLoading(false)
      const message =
        error?.response?.data?.message ||
        error?.message ||
        'Ocurrió un error al obtener los avisos.'
      setErrorMessage(message)
    }
  }

  const handleConfirm = (producto: IProduct, isEdit: boolean) => {
    if (isEdit) {
      setProducts((prevState) =>
        prevState.map((prod) => (prod.id === producto.id ? producto : prod))
      )
    } else {
      setProducts((prevState) => [producto, ...prevState])
    }
    setProductSelected(null)
  }

  const handleEditProduct = (e: React.MouseEvent<HTMLButtonElement>, product: IProduct) => {
    e.stopPropagation()
    setProductSelected(product)
  }

  return (
    <div id='marketplace'>
      <div className='row'>
        <div className='col-12 text-end d-lg-flex justify-content-lg-between'>
          <button
            type='button'
            className='btn btn-sm fw-bold btn-transparent ml-2 w-100 w-lg-auto text-primaryamsm'
            disabled={loading}
            onClick={() => {
              navigate('/marketplace')
            }}
          >
            <i className='ki-duotone ki-exit-left fs-2x text-primaryamsm'>
              <span className='path1'></span>
              <span className='path2'></span>
            </i>{' '}
            Volver al Marketplace
          </button>
          <button
            type='button'
            className='btn btn-sm fw-bold btn-success ml-2 w-100 w-lg-auto'
            disabled={loading}
            onClick={() => {
              setProductSelected({})
            }}
          >
            <i className='ki-duotone ki-plus fs-2x text-white'></i> Añadir aviso
          </button>
        </div>
      </div>
      <div
        className={`row mt-8 bg-white py-4 m-0 rounded-4 ${
          products.length === 0 || loading ? 'd-flex align-items-center' : ''
        }`}
        style={{minHeight: 'calc(100vh - 400px)'}}
      >
        {loading ? (
          <div className='text-center text-primary'>
            <div className='spinner-border text-primary'></div>
            <div className='fs-6 fw-bold'>CARGANDO MIS AVISOS...</div>
          </div>
        ) : (
          <div className='row'>
            {products.map((product: IProduct, index) => (
              <div className='col-12 col-md-6 col-xxl-3 mb-6' key={index}>
                <div className='rounded-4'>
                  <div
                    className='product-img rounded-4 cursor-pointer position-relative'
                    onClick={() => setImg(product.imagen)}
                  >
                    {/* {product.rut === currentUser?.rut && (
                    )} */}
                    <button
                      className='btn position-absolute rounded-circle bg-white top-0 end-0 m-2'
                      style={{height: 40, width: 40, padding: 7}}
                      onClick={(e: React.MouseEvent<HTMLButtonElement>) =>
                        handleEditProduct(e, product)
                      }
                      title='Editar aviso'
                    >
                      <i className='ki-duotone ki-pencil fs-2x text-primary'>
                        <span className='path1'></span>
                        <span className='path2'></span>
                      </i>
                    </button>
                    <LazyImage src={product.imagen} alt='product' />
                  </div>
                  <div className='pt-4 product-content'>
                    <div className='d-flex align-items-center'>
                      <div className='fw-bold fs-6 text-truncate'>
                        {product.titulo.toUpperCase()}{' '}
                      </div>
                      {product.vigente === '0' ? (
                        <i
                          className='ki-duotone ki-eye-slash cursor-pointer text-danger fs-2x'
                          title='No visible para otros usuarios'
                        >
                          <span className='path1'></span>
                          <span className='path2'></span>
                          <span className='path3'></span>
                          <span className='path4'></span>
                        </i>
                      ) : (
                        ''
                      )}
                    </div>
                    <p className='fw-light description text-justify m-0'>{product.descripcion}.</p>
                    <p className='fw-light text-primaryamsm fw-bold m-0'>{product.contacto}</p>
                  </div>
                </div>
              </div>
            ))}
            {products.length === 0 && !loading && (
              <div className='text-center w-100 py-10 text-gray-400 fs-1 fw-bold'>
                NO SE ENCONTRARON AVISOS
              </div>
            )}
          </div>
        )}
      </div>

      <Modal show={!!img} size='lg' onHide={() => setImg('')} centered>
        <Modal.Body className='p-0'>
          <img src={img} alt='Zoom' className='img-fluid w-100' />
        </Modal.Body>
      </Modal>

      <ModalProduct
        show={!!productSelected}
        onHide={() => setProductSelected(null)}
        onConfirm={handleConfirm}
        product={productSelected}
      />

      <AlertDialog
        message={errorMessage}
        show={!!errorMessage}
        onConfirm={() => setErrorMessage('')}
        title='Error'
      />
    </div>
  )
}

export default MyProducts
